<template>
    <v-dialog
        persistent
        v-model="dialog"
        content-class="dialog-box"
        max-width="600px"
        v-if="content">
        <v-btn
            slot="activator"
            flat
            @click="resetContent()"
            data-qe-id="transaction-hub_edit_btn"
            fab
            small
            v-if="content.canEdit && !!content.body">
            <v-icon>edit</v-icon>
        </v-btn>
        <v-btn
            slot="activator"
            color="ypo_blue white--text"
            v-if="content.canEdit && (!content.body || content.body.length === 0)"
            data-qe-id="transaction-hub_add_btn"
            class="dialog-box__add-message">
            {{addBtnMessage}}
        </v-btn>
        <v-card>
            <v-flex xs12 class="dialog-box__title">
                <v-flex tag="h2"> {{communityCommonConstant.transactionHub.TITLE}}</v-flex>
            </v-flex>
            <v-card-text px-0>
                <v-container px-0 pt-0>
                    <v-layout wrap>
                        <v-flex sm12>
                            <ck-editor
                                :editor-id="ckEditorId"
                                :can-upload-image="false"
                                v-model="newContent.body"
                                data-qe-id="transaction-hub_editor"
                                class="ck-editor__font">
                            </ck-editor>
                        </v-flex>
                    </v-layout>
                </v-container>
                <status-bar :action="saveAction"></status-bar>
            </v-card-text>
            <v-flex text-xs-right>
                <v-btn class="primary_btn transparent" flat @click.native="closeDialog()" data-qe-id="cancel_dialog_btn">
                    {{appCommonConstants.CANCEL}}
                </v-btn>
                <v-btn class="primary_btn" dark @click.native="saveContent()" data-qe-id="save_dialog_btn">
                    {{appCommonConstants.SAVE}}
                </v-btn>
            </v-flex>
        </v-card>
    </v-dialog>
</template>

<script>
    import { communityCommonConstant } from "../communityCommon.constant";
    import { appCommonConstants, routerNames } from "../../appCommon.constants";
    import { mapActions, mapState } from "vuex";
    import { storeAction } from "@/store/storeActions.constant";
    import { storeGetters } from '@/store/storeGetters.constant';
    import CkEditor from "../../CkEditor/CkEditor";
    import StatusBar from "../../StatusBar/StatusBar";
    import { getRandomId } from "@/common/utils/utils";

    export default {
    name: "EditTransactionHub",
    components: {
        StatusBar,
        CkEditor,
    },
    props: {
        content: {
        type: Object,
            required: true,
        },
    },
    created() {
        this.$watch(() => this.$store.getters[storeGetters.communityIdPromise], () => { this.files = []; });
    },
    data() {
        return {
            dialog: false,
            communityCommonConstant,
            getRandomId,
            appCommonConstants,
            files: [],
            newContent: Object.assign({}, this.content),
            ckEditorId: getRandomId(),
        };
    },
    methods: {
        ...mapActions({
            saveTransactionHubContent: `chapter/${storeAction.saveTransactionHubContent}`,
        }),
        closeDialog() {
            this.dialog = false;
            /* eslint-disable-next-line no-undef*/
            CKEDITOR.instances[this.ckEditorId].setData(this.content.body);
        },
        resetContent() {
            this.newContent = { ...this.content };
            /* eslint-disable-next-line no-undef*/
            CKEDITOR.instances[this.ckEditorId].setData(this.content.body);
        },
        saveContent() {
            const saveData = {
                body: this.newContent.body,
                communityId: this.$route.params.communityId,
            };

            this.saveTransactionHubContent(saveData).then(() => {
                this.dialog = false;
            });
        },
    },
    computed: {
        ...mapState("actionState", ["actions"]),
        
        saveAction() {
            return this.actions[storeAction.saveTransactionHubContent];
        },
        addBtnMessage() {
            const messages = this.communityCommonConstant.transactionHub;
            switch (this.$route.name) {
                case routerNames.NETWORK: return messages.ADD_TRANSACTION_HUB_CONTENT;
                case routerNames.HOME: return messages.ADD_TRANSACTION_HUB_CONTENT;
                default: return '';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    @import "../../../common/styles/_colors.scss";
    @import "../../../common/styles/_responsive.scss";
    @import "../../../common/styles/_commonClasses.scss";

    .dialog-box {
        &__title {
            text-align: center;
            height: 100px;
            background-color: $ypo-dark-background-gray;
            color: $white;
            padding-top: 20px;
        }

        &__add-message {
            font-size: 11px;
        }

        &__image {
            &-frame {
                padding: 10px;
                padding-left: 23px;
                padding-right: 23px;
                max-height: 250px;
                overflow-y: auto;
            }

            &-container {
                position: relative;
            }

            &-remove {
                position: absolute !important;
                z-index: 10000;
                top: -10px;
                right: 0;
                transform: translate3d(50%, 0, 0);
                border: none;
                width: 45px;
                height: 45px;
                margin: 0;
            }
        }

        &__chair-des {
            text-align: center;
            font-size: 15px !important;
            color: $ypo-blue;
        }

        .heading {
            height: 29px !important;
            width: 170px !important;
            color: rgba(84, 110, 122, 0.9) !important;
            font-family: Raleway, serif !important;
            font-size: 24px !important;
            letter-spacing: 0.17px !important;
            margin-top: 25px;
        }

        &__textarea {
            height: 100%;
            width: 100%;
            border-left: 1px solid $ypo-title-blue-gray;
            border-right: 1px solid $ypo-title-blue-gray;
            border-top: 1px solid $ypo-title-blue-gray;
            border-radius: 4px;
            padding: 8px;
        }

        &__img-format {
            border-radius: 50% !important;
            height: 96px;
            width: 96px;
            margin-top: 4px;
            border: 5px solid $ypo-title-blue-gray;
        }

        &__save_btn {
            border: 1px solid $ypo-text-border !important;
            border-radius: 4px;
            background-color: $ypo-blue !important;
            font-family: Gentona, Arial, Helvetica, sans-serif !important;
            font-size: 14.44px !important;
            font-weight: bold !important;
            letter-spacing: 1.25px !important;
        }

        &__close_btn {
            border-radius: 4px !important;
            color: #222222 !important;
            font-family: Gentona, Arial, Helvetica, sans-serif !important;
            font-size: 15.44px !important;
            font-weight: 600 !important;
            letter-spacing: 1.25px !important;
            line-height: 16px !important;
            text-align: center !important;
        }

        .v-card__text {
            padding-top: 16px;
            font-size: 16px;
            color: rgb(102, 102, 102);
        }

        &__text-right {
            float: right;
        }

        &__color-Text {
            color: $ypo-blue;
            font-weight: bold;
            float: right;
        }

        &__color-light {
            font-weight: lighter;
            color: $ypo-duskblue;
            text-align: justify;
            text-overflow: ellipsis;
            overflow: hidden;
            padding-top: 0;
        }

        &__text-Position {
            font-weight: bold;
            text-overflow: ellipsis;
        }

        &__btn-align {
            margin-left: 370px;
            color: $ypo-blue;
            font-weight: bold;
        }

        &__padding-space {
            padding-bottom: 0;
        }

        &__font-format {
            font-weight: lighter;
            margin-top: 25px;
            font-size: 25px;
        }

        &__chapter-name {
            margin-top: 33px;
            text-align: center;
        }

        &__message-desc-border {
            border-bottom: 1px solid $ypo-text-border;
            margin-top: 35px;
        }

        &__padding-text-left {
            padding-left: 40px;
        }
    }
</style>
